import { useCallback } from "react";
import useWeb3 from "../useWeb3";
// import { useWeb3React } from "@web3-react/core";
import { getTrade } from "../../utils/contractHelpers";

const WinnerCheck = () => {
    const web3 = useWeb3();

    const WinnerCheckHook = useCallback(async (address) => {
        const contract = getTrade(address, web3);
        const currentWinner = await contract.methods.winner().call()
        return currentWinner;
    }, [web3]);
    return { WinnerCheckHook };
};

export default WinnerCheck;
